import { Box, styled } from "@mui/material";

export const CardHeader = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(6)}`,
  borderBottom: `1px solid ${theme.palette.biarri.primary.lightGrey}`,
}));
